import { Form } from 'factorial-form'
import { makeObservable, observable } from 'mobx'

import AccessGroupStrategies from './AccessGroupStrategies'
import { PeriodType } from './TimePeriod'

interface TimePeriodAttributes {
  _destroy: boolean
  period_type: PeriodType
}
class PolicyUpdateForm extends Form {
  saved = false

  constructor(values: object) {
    super(values, {
      name: 'string',
      leave_type_ids: 'any',
      time_periods: 'any',
      strategy: 'any',
      team_ids: 'any',
      location_ids: 'any',
      members: 'any',
      legal_entity_ids: 'any',
    })

    makeObservable(this, { saved: observable })
  }

  get timePeriods() {
    const values = this.get('time_periods').value
    return values.filter((timePeriod: TimePeriodAttributes) => {
      return !timePeriod._destroy
    })
  }

  get isValid() {
    const validName = !!this.get('name').value
    const validLeaveTypes = !!this.get('leave_type_ids').value.length
    const validMembers = this.isMembers ? !!this.get('members').value.length : true
    const validFqlMultiselect = this.isFqlMultiselect
      ? !!this.get('team_ids').value.length || !!this.get('location_ids').value.length
      : true

    return validName && validLeaveTypes && validMembers && validFqlMultiselect
  }

  get hasMultipleContractPeriods() {
    const contractPeriods = this.timePeriods.filter((timePeriod: TimePeriodAttributes) => {
      return timePeriod.period_type === PeriodType.by_contract_start_date
    })
    return contractPeriods.length > 1
  }

  get hasContractPeriods() {
    const periods = this.get('time_periods').value.filter((timePeriod: TimePeriodAttributes) => {
      return !timePeriod._destroy && timePeriod.period_type === PeriodType.by_contract_start_date
    })
    return periods.length >= 1
  }

  get hasTimeRangePeriods() {
    const periods = this.get('time_periods').value.filter((timePeriod: TimePeriodAttributes) => {
      return !timePeriod._destroy && timePeriod.period_type === PeriodType.by_time_range
    })
    return periods.length >= 1
  }

  get isMembers(): boolean {
    return this.get('strategy').value === AccessGroupStrategies.members
  }

  get isFqlMultiselect(): boolean {
    return this.get('strategy').value === AccessGroupStrategies.fqlMultiselect
  }
}

export default PolicyUpdateForm
